export const text = {
    en: {
        title: "Groups Management",
        subtitle: "Manage groups and assign employees",
        myGroups: "My Groups",
        allGroups: "All Groups",
        createGroup: "Create Group",
        assignEmployees: "Assign Employees",
        groupName: "Group Name",
        creator: "Creator",
        actions: "Actions",
        noGroups: "No groups found",
        noGroupsMessage: "You are not a member of any groups yet",
        createGroupTitle: "Create New Group",
        enterGroupName: "Enter group name",
        assignEmployeesTitle: "Assign Employees to Group",
        employeeIds: "Employee IDs",
        employeeIdsPlaceholder: "Enter employee IDs (comma-separated, e.g., 11,12,13)",
        cancel: "Cancel",
        create: "Create",
        assign: "Assign",
        loading: "Loading...",
        search: "Search groups...",
        adminOnly: "Admin/Manager Only",
        groupCreated: "Group created successfully",
        employeesAssigned: "Employees assigned successfully",
        failedToCreate: "Failed to create group",
        failedToAssign: "Failed to assign employees",
        unauthorized: "You must be an admin or manager to perform this action",
        memberOfGroups: "Member Of Groups",
        createdGroups: "Created Groups",
        groupNameIsRequred: "Group name is required",
        noCreatedGroups: "No created groups",
        noCreatedGroupsMessage: "You haven't created any groups yet",
        createdAt: "Created At",
        selectEmployees: "Select Employees",
        selectEmployeesHint: "Hold Ctrl/Cmd to select multiple employees",
        selectGroup: "Select Group",
        chooseGroup: "Choose a group...",
        atLeastOneEmployee: "Group and at least one employee are required",
    },
    ar: {
        title: "إدارة المجموعات",
        subtitle: "إدارة المجموعات وتعيين الموظفين",
        myGroups: "مجموعاتي",
        allGroups: "جميع المجموعات",
        createGroup: "إنشاء مجموعة",
        assignEmployees: "تعيين موظفين",
        groupName: "اسم المجموعة",
        creator: "المنشئ",
        actions: "الإجراءات",
        noGroups: "لم يتم العثور على مجموعات",
        noGroupsMessage: "أنت لست عضوًا في أي مجموعات حتى الآن",
        createGroupTitle: "إنشاء مجموعة جديدة",
        enterGroupName: "أدخل اسم المجموعة",
        assignEmployeesTitle: "تعيين موظفين للمجموعة",
        employeeIds: "معرفات الموظفين",
        employeeIdsPlaceholder: "أدخل معرفات الموظفين (مفصولة بفواصل، مثال: 11,12,13)",
        cancel: "إلغاء",
        create: "إنشاء",
        assign: "تعيين",
        loading: "جاري التحميل...",
        search: "البحث في المجموعات...",
        adminOnly: "للمسؤولين/المديرين فقط",
        groupCreated: "تم إنشاء المجموعة بنجاح",
        employeesAssigned: "تم تعيين الموظفين بنجاح",
        failedToCreate: "فشل في إنشاء المجموعة",
        failedToAssign: "فشل في تعيين الموظفين",
        unauthorized: "يجب أن تكون مسؤولاً أو مديرًا لتنفيذ هذا الإجراء",
        memberOfGroups: "عضو في المجموعات",
        createdGroups: "المجموعات المنشأة",
        groupNameIsRequred: "برجاء كتابة اسم المجموعه",
        noCreatedGroups: "لا توجد مجموعات منشأة",
        noCreatedGroupsMessage: "لم تقم بإنشاء أي مجموعات بعد",
        createdAt: "تاريخ الإنشاء",
        selectEmployees: "اختر الموظفين",
        selectEmployeesHint: "اضغط Ctrl/Cmd لاختيار موظفين متعددين",
        selectGroup: "اختر المجموعة",
        chooseGroup: "اختر مجموعة...",
        atLeastOneEmployee: "المجموعة وموظف واحد على الأقل مطلوبان",
    }
};